<template>
    <div class="promo--menu" id="promo--menu">
        <div class="center">
            <b-navbar toggleable="lg" type="dark">
                <b-navbar-toggle class="promo--nav-collapse" target="nav-collapse">
                    <span id="hamburguer"></span>
                </b-navbar-toggle>

                <div class="only-mob-flex--lg align-items-center" @click="closeMenuMobile" is-nav>
                    <div class="logo-promo--mobile me-3">
                        <a @click="navigate(menuItems[0])"><img src="absoluto/assets/images/logo-mobile.webp?t=2" alt=""></a>
                    </div>
                    <BtnMenu/>
                </div>

                <b-collapse id="nav-collapse" class="" is-nav>
                    <b-navbar-nav class="promo--navbar-nav justify-content-around">
                        <b-nav-item
                            v-for="(item, key) in menuItems"
                            :key="key"
                            :class="{ activeItem: $route.path == item.linkActive }"
                        >
                            <div
                                @click="sendGA('menu-bar-click-' + item.slug); navigate(item)"
                            >
                                {{ item.label }}
                            </div>
                        </b-nav-item>

                        <div class="only-desk-flex--lg">
                            <BtnMenu/>
                        </div>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
        </div>
    </div>
</template>

<script>
import {
    scroller
} from "vue-scrollto/src/scrollTo";
import _ from "lodash";

export default {
    name: "Menu",
    components: {
        BtnMenu: () => import("../components/BtnMenu"),
    },
    data() {
        return {
            activeItem: "/home/",
            imgLogo: '../absoluto/assets/images/logo.png',
            menuItems: [
                {
                    id: 1,
                    label: 'Home',
                    slug: 'home',
                    param: '#home',
                    path: '/home/',
                    linkActive: '/home/'
                },
                {
                    id: 2,
                    label: 'Como participar',
                    slug: 'como-participar',
                    param: '#como_participar',
                    path: '/home/como_participar',
                    linkActive: '/home/como_participar'
                },
                {
                    id: 3,
                    label: 'Prêmios',
                    slug: 'premios',
                    param: '#premios',
                    path: '/home/premios',
                    linkActive: '/home/premios'
                },
                {
                    id: 4,
                    label: 'Produtos participantes',
                    slug: 'produtos-participantes',
                    param: '#produtos_participantes',
                    path: '/home/produtos_participantes',
                    linkActive: '/home/produtos_participantes'
                },
                {
                    id: 5,
                    label: 'Ganhadores',
                    slug: 'ganhadores',
                    path: '/ganhadores',
                    linkActive: '/ganhadores'
                },
                {
                    id: 6,
                    label: 'Regulamento',
                    slug: 'regulamento',
                    path: '/regulamento',
                    linkActive: '/regulamento'
                },
                {
                    id: 7,
                    label: 'Dúvidas',
                    slug: 'duvidas',
                    path: '/duvidas',
                    linkActive: '/duvidas'
                },

            ],
        };
    },

    methods: {
        sendGA(eventName, options = {}) {
            gtag('event', eventName, options);
        },
        navigateTo(path, pageId) {
            this.$router.push({
                path: path,
                query: this.$route.query
            }).catch(()=>{});
            this.$parent.scrollPageSite(pageId);
        },
        setMenuScroll(path, pageId) {
            this.navigateTo(path, pageId);
        },

        navigate(item) {
            if (item.path !== this.$router.currentRoute.path) {
                this.$router.push({ path: item.path, query: this.$route.query }).catch(()=>{});
            }

            if (item.param) {
                const firstScrollTo = scroller();
                this.navigateTo(item.path, item.param.replace('#', ''));
                setTimeout(() => {
                    firstScrollTo(item.param, 200, {
                        offset: (window.innerWidth <= 768) ? -document.getElementById('promo--menu')
                            .offsetHeight : -document.getElementById('promo--menu').offsetHeight
                    });
                }, 400);
            }
        },
        closeMenuMobile() {
            const btnMenuMob = document.querySelector('.promo--nav-collapse');

            setTimeout(() => {
                if (btnMenuMob.classList.contains('not-collapsed')){
                    btnMenuMob.click();
                }
            }, 600)

        },
    },

    mounted() {
        const thisVue = this;

        if (thisVue.$route.name == 'Index')
            thisVue.setMenuScroll("/home/", 'home');

        window.document.body.onscroll = function () {
            if (thisVue.$route.name == 'Home' || thisVue.$route.name == 'Home.page') {
                let _top = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                let sections = document.querySelectorAll("section");
                let section = _.find(sections, function (value) {
                    return (
                        (_top + (window.screen.height / 3)) >= value.offsetTop &&
                        (_top + (window.screen.height / 3)) <= value.offsetTop + value
                            .offsetHeight - 1
                    );
                });
                if (_.get(section, 'id', false)) {
                    if (thisVue.$route.path != document.getElementById(section.id).getAttribute("name")) {
                        thisVue.setMenuScroll(document.getElementById(section.id).getAttribute("name"), section.id);
                    }
                }

            }
        }
    },
};
</script>


<style lang="scss" scoped>
@import "../assets/scss/global";

//-> MENU FLUTUANTE
.promo--menu {
    width: 100%;
    top: 0;
    left: 0;
    position: fixed;
    z-index: 9;
    background: $cor1; //rgba($cor1, .95);

    //-> BOTAO MENU MOBILE
    .promo--nav-collapse {
        margin: 0 .5rem 0 0 !important;
        height: 42px;
        padding: 0 12px;
        border: none;
    }

    //logo mobile
    .logo-promo--mobile {
        margin-right: 1rem;

    }

    .center {
        @media (min-width: $screenLG) {
            max-width: none;
            width: 100%;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
        }

        .navbar {
            padding: 0.5rem;
            @media (min-width: $screenLG) {
                width: 100%;
                height: $menuHeight;
                display: flex;
                flex-flow: row nowrap;
                align-items: stretch;
                padding: 0;
                box-shadow: 0 5px 5px 0 rgba($black, .3);
                // align-items: center;
                // justify-content: space-between;
            }

            .navbar-brand {
                height: $menuHeight;
                display: flex;
                flex-flow: row nowrap;
                align-items: center;
                justify-content: flex-start;
                flex-flow: row;
                padding: 0 0.5rem;
                flex-shrink: 1;
            }
        }
    }

    //-> MENU E DROP MENU
    .promo--navbar-nav {
        width: 100%;
    }

    .promo--navbar-nav,
    .promo--navbar-nav-drop {
        font-size: $fontMenu !important;

        .nav-item {
            display: flex;
            align-items: center;
        }

        .nav-item, em {
            text-transform: uppercase;
            font-family: $font !important;
            font-size: $fontMenu !important;

            .nav-link {
                color: $corMenu;
                font-family: $font !important;
                font-size: $fontMenu !important;
                outline: none;
            }
        }


    }


    //-> WRAP LOGO BRAND E BUTON MOBILE COLLAPSE
    .promo--navbar-nav {
        height: 100%;
        @media (min-width: 992px) {
            display: flex;
            align-items: stretch;
            flex-flow: row;
        }

        .nav-item {
            a {
                transition: color .5s linear;
                position: relative;
                z-index: 0;

                @media (min-width: 992px) {
                    margin: 0 0.4rem;
                    padding: 0;
                }

                &:before {
                    opacity: 0;
                    content: '';
                    position: absolute;
                    bottom: 0px;
                    left: 50%;
                    transform: translateX(-50%);
                    z-index: 2;
                    width: 0%;
                    height: 3px;
                    background: $corMenuActived;
                    transition: width .5s ease, opacity .2s linear;
                }

                //}
            }

            //-> MENU HOVER E ATIVO
            &.activeItem,
            &:hover {
                a {
                    color: $corMenuActived;

                    &:before {
                        @media(min-width: $screenLG) {
                            opacity: 1;
                            width: 100%;
                            height: 3px;
                            background: $corMenuActived;
                        }
                    }
                }
            }
        }
    }

    //-> DROP DOWN MENU
    .promo--navbar-nav-drop {
        @media (max-width: $screenLG) {
            margin-top: 10px;
        }

        .nav-item {
            .nav-link {
                font-size: $fontMenu !important;

                &::after {
                    color: #fff !important;
                }
            }
        }

        em {
            font-style: normal;
            color: $white;
        }

    }

    @media (max-width: $screenLG) {

        .dropdown-menu.dropdown-menu-right {
            position: absolute !important;
        }

        // .navbar.navbar-expand-lg {
        //     //height: 100vh;
        // }

        .promo--nav-collapse {
            background-color: $cor4;

            &:hover, &:focus, &:active {
                background-color: $cor4 !important;
                filter: brightness(1);
                box-shadow: none;
            }

            #hamburguer{
                display: block;
                border-top: 2px solid $white;
                width: 20px;
                &:after, &:before{
                    content: "";
                    display: block;
                    width: 20px;
                    height: 2px;
                    background: $white;
                    margin-top: 5px;
                    transition: .3s;
                    position: relative;
                }
            }
            &.not-collapsed{
                #hamburguer{
                 border-top-color: transparent;
                }
                #hamburguer::before{
                    transform: rotate(135deg);
                }
                #hamburguer::after{
                    transform: rotate(-135deg);
                    top: -7px;
                }
            }
        }
        .promo--navbar-nav {
            height: auto;

            .nav-item .nav-link {
                font-size: 24px !important;
            }
        }
    }
}
</style>
